/**
 * Shared Cart Modal - Gerencia o modal para exibir carts compartilhados
 * Detecta parâmetro ?shared-cart=ID na URL e busca dados da API
 */

class SharedCartModal {
  constructor() {
    this.modal = null;
    this.isInitialized = false;
    this.removeIconUrl = document.getElementById('sharedCartAssets')?.dataset.removeIconUrl || '';
    this.successImageUrl = document.getElementById('sharedCartAssets')?.dataset.successImageUrl || '';
    this.init();
  }

  init() {
    if (this.isInitialized) return;
    this.checkSharedCartParameter();
    this.setupUrlChangeListener();
    this.isInitialized = true;
  }

  async checkSharedCartParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const sharedCartId = urlParams.get('shared-cart');
    
    if (sharedCartId) {
      await this.showCartData(sharedCartId);
      this.clearUrlParameter();
    }
  }

  setupUrlChangeListener() {
    if (window.history && window.history.pushState) {
      const originalPushState = window.history.pushState;
      const originalReplaceState = window.history.replaceState;
      
      window.history.pushState = (...args) => {
        originalPushState.apply(this, args);
        this.checkSharedCartParameter();
      };
      
      window.history.replaceState = (...args) => {
        originalReplaceState.apply(this, args);
        this.checkSharedCartParameter();
      };
    }
  }

  async showCartData(cartId) {
    try {
      if (!window.SHARED_CART_CONFIG?.validate()) {
        this.showModal('Configuração da API não encontrada. Configure o arquivo shared-cart-config.js', false);
        return;
      }

      this.showModal(window.SHARED_CART_CONFIG.MODAL.MESSAGES.LOADING, true);
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), window.SHARED_CART_CONFIG.REQUEST_TIMEOUT);
      
      const response = await fetch(
        window.SHARED_CART_CONFIG.getApiUrl(cartId),
        {
          headers: window.SHARED_CART_CONFIG.API_HEADERS,
          signal: controller.signal
        }
      );
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('NOT_FOUND');
        }
        throw new Error('API_ERROR');
      }
      
      const cartData = await response.json();
      console.log('cartData:', cartData)
      
      if (window.SHARED_CART_CONFIG) {
        window.SHARED_CART_CONFIG.cartData = cartData;
      }
      
      this.showModal(cartData, false);
      
      window.SHARED_CART_CONFIG.log('info', 'Cart carregado com sucesso', { cartId, data: cartData });
      
    } catch (error) {
      window.SHARED_CART_CONFIG.log('error', 'Erro ao buscar dados do cart', { cartId, error: error.message });
      
      let errorMessage = window.SHARED_CART_CONFIG.MODAL.MESSAGES.ERROR;
      
      if (error.name === 'AbortError') {
        errorMessage = 'Tempo limite excedido. Tente novamente.';
      } else if (error.message === 'NOT_FOUND') {
        errorMessage = window.SHARED_CART_CONFIG.MODAL.MESSAGES.NOT_FOUND;
      } else if (error.message === 'API_ERROR') {
        errorMessage = window.SHARED_CART_CONFIG.MODAL.MESSAGES.ERROR;
      } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
        errorMessage = window.SHARED_CART_CONFIG.MODAL.MESSAGES.NETWORK_ERROR;
      }
      
      this.showModal(errorMessage, false);
    }
  }

  showModal(content, isLoading = false) {
    this.createModalIfNeeded();
    
    const contentDiv = document.getElementById('shared-cart-content');
    
    if (isLoading) {
      contentDiv.innerHTML = '<div class="shared-cart-loading">Carregando...</div>';
    } else if (typeof content === 'string') {
      contentDiv.innerHTML = `<p>${content}</p>`;
    } else {
      contentDiv.innerHTML = this.renderCartData(content);
    }
    
    this.modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  createModalIfNeeded() {
    if (this.modal) return;
    
    this.modal = document.createElement('div');
    this.modal.id = 'shared-cart-modal';
    this.modal.className = 'shared-cart-modal';
    this.modal.innerHTML = `
      <div class="shared-cart-modal__overlay"></div>
      <div class="shared-cart-modal__content">
        <div class="shared-cart-modal__header">
          <h3>Carrinho Compartilhado</h3>
          <button class="shared-cart-modal__close" onclick="sharedCartModal.close()">
            <span>&times;</span>
          </button>
        </div>
        <div class="shared-cart-modal__body">
          <div id="shared-cart-content"></div>
        </div>
      </div>
    `;
    
    document.body.appendChild(this.modal);
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.modal.addEventListener('click', (event) => {
      if (event.target.classList.contains('shared-cart-modal__overlay')) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.style.display === 'flex') {
        this.close();
      }
    });
  }

  renderCartData(cartData) {
    if (!cartData.cart || !cartData.cart.lineItems || !Array.isArray(cartData.cart.lineItems)) {
      return `
        <div class="shared-cart-data">
          <p>Nenhum item encontrado no carrinho.</p>
        </div>
      `;
    }

    const lineItems = cartData.cart.lineItems;
    console.log('lineItems:', lineItems);
    
    return `
      <div class="shared-cart-data">
        <div class="shared-cart-items">
          ${lineItems.map((item, index) => `
            <div class="shared-cart-item" data-item-index="${index}">
              <div class="shared-cart-item-image">
                ${item.image ? `<img src="${item.image}" alt="${item.title || 'Produto'}" class="shared-cart-item-img">` : ''}
              </div>
              <div class="shared-cart-item-info">
                <h5 class="shared-cart-item-title">${item.title || 'Produto sem título'}</h5>
                <div class="shared-cart-item-quantity">
                <p>Quantidade:</p>
                  <div class="shared-cart-item-quantity-controls">
                    <button class="quantity-btn quantity-minus" onclick="sharedCartModal.updateQuantity(${index}, -1)" type="button">-</button>
                    <span class="quantity-value">${item.quantity || 1}</span>
                    <button class="quantity-btn quantity-plus" onclick="sharedCartModal.updateQuantity(${index}, 1)" type="button">+</button>
                  </div>
                </div>
              </div>
              <div class="shared-cart-item-actions">
                <button class="shared-cart-remove-btn" onclick="sharedCartModal.removeItem(${index})" title="Remover item">
                  <img src="${this.removeIconUrl}" alt="Remover item" class="shared-cart-remove-icon">
                </button>
              </div>
            </div>
          `).join('')}
        </div>
        <div class="shared-cart-actions">
          <button class="shared-cart-add-all-btn" onclick="sharedCartModal.addAllToCart()">
            Adicionar ao Carrinho
          </button>
          <button class="shared-cart-cancel-btn" onclick="sharedCartModal.close()">
            Voltar às compras
          </button>          
        </div>
      </div>
    `;
  }


  updateQuantity(itemIndex, change) {
    const cartConfig = window.SHARED_CART_CONFIG;
    if (!cartConfig?.cartData?.cart?.lineItems) {
      console.error('Dados do carrinho não encontrados para atualizar quantidade.');
      return;
    }

    const lineItems = cartConfig.cartData.cart.lineItems;
    const item = lineItems[itemIndex];

    if (!item) {
      console.error('Item não encontrado no índice:', itemIndex);
      return;
    }

    const newQuantity = (item.quantity || 1) + change;

    if (newQuantity < 1) {
      this.removeItem(itemIndex);
      return;
    }
    
    item.quantity = newQuantity;
    
    this.showModal(cartConfig.cartData, false);
  }


  removeItem(itemIndex) {
    if (!window.SHARED_CART_CONFIG?.cartData?.cart?.lineItems) {
      console.error('Dados do carrinho não encontrados');
      return;
    }

    const lineItems = window.SHARED_CART_CONFIG.cartData.cart.lineItems;
    
    if (itemIndex < 0 || itemIndex >= lineItems.length) {
      console.error('Índice de item inválido');
      return;
    }

    lineItems.splice(itemIndex, 1);
    
    window.SHARED_CART_CONFIG.cartData.cart.lineItems = lineItems;
    
    this.showModal(window.SHARED_CART_CONFIG.cartData, false);
    
  }


  async addAllToCart() {
    if (!window.SHARED_CART_CONFIG?.cartData?.cart?.lineItems) {
      console.error('Dados do carrinho não encontrados');
      this.showModal('Erro: Dados do carrinho não encontrados.', false);
      return;
    }

    const lineItems = window.SHARED_CART_CONFIG.cartData.cart.lineItems;
    
    const itemsToAdd = lineItems.filter(item => item.variant_id || item.variantId);
    
    if (itemsToAdd.length === 0) {
      this.showModal('Erro: Nenhum item válido encontrado para adicionar ao carrinho.', false);
      return;
    }

    this.showModal('Adicionando itens ao carrinho...', true);

    try {
      await this.addItemsToCart(itemsToAdd);
      
      await this.applyDiscountCodes();
      
      // this.showSuccessMessage();
      
      await this.updateCartDisplay();

      this.showModal('Itens adicionados', false);
      this.showModal('Itens adicionados', false);

    } catch (error) {
      console.error('Erro ao adicionar itens ao carrinho:', error);
      this.showModal(`Erro: ${error.message}`, false);
    }
  }

  async addItemsToCart(itemsToAdd) {
    const items = itemsToAdd.map(item => ({
      id: item.variant_id || item.variantId,
      quantity: item.quantity || 1
    }));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Erro ao adicionar itens ao carrinho');
    }

    const result = await response.json();
    console.log('Itens adicionados com sucesso:', result);
    return result;
  }

  async applyDiscountCodes() {
    if (!window.SHARED_CART_CONFIG?.cartData?.cart?.discountCodes) {
      console.log('Nenhum código de desconto encontrado no carrinho compartilhado');
      return;
    }

    const discountCodes = window.SHARED_CART_CONFIG.cartData.cart.discountCodes;
    
    if (!Array.isArray(discountCodes) || discountCodes.length === 0) {
      console.log('Nenhum código de desconto válido encontrado');
      return;
    }

    if (!window.DiscountManager) {
      console.warn('DiscountManager não está disponível, pulando aplicação de descontos');
      return;
    }

    try {
      const discountManager = new window.DiscountManager();
      const results = await discountManager.applyMultipleDiscounts(discountCodes);
      
      if (results.success.length > 0) {
        console.log(`Códigos de desconto aplicados com sucesso: ${results.success.join(', ')}`);
      }
      
      if (results.failed.length > 0) {
        console.warn(`Códigos de desconto que falharam: ${results.failed.join(', ')}`);
      }
      
    } catch (error) {
      console.error('Erro ao aplicar códigos de desconto:', error);
    }
  }

  showSuccessMessage() {
    const successHtml = `
      <div class="shared-cart-success">
        <img src="${this.successImageUrl}" alt="Sucesso" class="shared-cart-success-image">
        <div class="shared-cart-success-content">
          <h4>ITENS ADICIONADOS AO CARRINHO COM SUCESSO!</h4>
          <p>Os itens foram adicionados ao seu carrinho. Se não conseguir ver as atualizações clique em *Recarregar Página*.</P>
          <div class="shared-cart-success-actions">
            <button class="shared-cart-cancel-btn" onclick="sharedCartModal.close()">
              Voltar às compras
            </button>
          </div>
        </div>
      </div>
    `;
    
    this.showModal(successHtml, false);
  }


  reloadPage() {
    const url = new URL(window.location);
    url.searchParams.delete('shared-cart');
    window.location.href = url.toString();
  }


  async updateCartDisplay() {
    try {
      if (window.cartDrawer && typeof window.cartDrawer.renderContents === 'function') {
        console.log('Atualizando cart drawer...');
        const cartData = await fetch('/cart.js').then(r => r.json());
        window.cartDrawer.renderContents(cartData);
        return;
      }

      if (window.cartNotification && typeof window.cartNotification.renderContents === 'function') {
        console.log('Atualizando cart notification...');
        const cartData = await fetch('/cart.js').then(r => r.json());
        window.cartNotification.renderContents(cartData);
        return;
      }

      const cartElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count');
      if (cartElements.length > 0) {
        console.log('Atualizando contadores do carrinho...');
        const cartData = await fetch('/cart.js').then(r => r.json());
        const totalItems = cartData.item_count;
        
        cartElements.forEach(element => {
          element.textContent = totalItems;
        });
        return;
      }

      const cartSection = document.querySelector('#cart, .cart, [data-section-type="cart"]');
      if (cartSection) {
        console.log('Recarregando seção do carrinho...');
        const response = await fetch('/cart?section_id=main-cart-items');
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartContent = doc.querySelector('#cart, .cart, [data-section-type="cart"]');
          if (newCartContent) {
            cartSection.innerHTML = newCartContent.innerHTML;
          }
        }
        return;
      }

      console.log('Nenhum método de atualização encontrado, recarregando página...');
      setTimeout(() => {
        this.reloadPage();
      }, 1500);

    } catch (error) {
      console.error('Erro ao atualizar carrinho:', error);
      setTimeout(() => {
        this.reloadPage();
      }, 1500);
    }
  }

  close() {
    if (this.modal) {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  clearUrlParameter() {
    const newUrl = new URL(window.location);
    newUrl.searchParams.delete('shared-cart');
    window.history.replaceState({}, '', newUrl);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.sharedCartModal = new SharedCartModal();
});

window.SharedCartModal = SharedCartModal;


